export default {
    open: "Válaszolj most",
    approve: "Hagyja jóvá most",
    impersonation: {
        title: "Ön a(z) «{name}» nevében rendel.",
        cta: "Válts vissza magamra",
    },
    "You have an unapproved orders": "Jóváhagyandó parancsai vannak",
    "You have orders to approve": "Jóváhagyandó parancsai vannak"
}